import { render, staticRenderFns } from "./AuthView.vue?vue&type=template&id=5a108583"
import script from "./AuthView.vue?vue&type=script&lang=js"
export * from "./AuthView.vue?vue&type=script&lang=js"
import style0 from "./AuthView.vue?vue&type=style&index=0&id=5a108583&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports